module.exports = __webpack_public_path__ + "static/the-art-of-learning-b337bee0b5f62bb7d4d465a278333352.jpg";